import React from "react";
import CustomTextarea from "../../../../../../../Components/CustomInputs/CustomTextarea";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const HospitalizationAdditionalInjuryDescriptionField: React.FC = () => {
   const dispatch = useDispatch();

   const AdditionalInjuryDescriptionValueHospitalization = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 1
         )?.additionalInjuryDescription
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const { isChild, isThirdPerson } = useSelector(
      (state: StoreType) => state.claimState.reportModel
   );
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, "hospitalization.AdditionalInjuryDescription");
   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "hospitalization",
            "AdditionalInjuryDescription",
            visibilityMatrixes
         )}
      >
         <CustomTextarea
            labelText={
               isChild || isThirdPerson
                  ? "Důvod hospitalizace"
                  : "Důvod vaší hospitalizace"
            }
            placeholderText={"Uveďtě, proč vás hospitalizovali"}
            name="AdditionalInjuryDescription"
            value={AdditionalInjuryDescriptionValueHospitalization || ""}
            onChange={(e) => {
               dispatch(
                  updateFirstStepDynamicFields({
                     value: e.target.value.slice(0, 240),
                     field: "additionalInjuryDescription",
                     typeOfClaimEnum: 1,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               "hospitalization.AdditionalInjuryDescription",
               claimFieldErrorsMessages
            )}
            inputRef={ref}
            maxCharacters="240"
            highlightMaxCharacters={
               AdditionalInjuryDescriptionValueHospitalization?.length === 240
            }
         />
      </WholeLineContainer>
   );
};

export default HospitalizationAdditionalInjuryDescriptionField;
